<template>
  <div class="edit-client">
    <el-form :model="clientData" ref="clientData" label-width="200px" class="edit-client-form">

      <el-form-item label="Name" prop="name">
        <el-input v-model="clientData.name"></el-input>
      </el-form-item>

      <el-form-item label="Address" prop="address">
        <el-input v-model="clientData.address"></el-input>
      </el-form-item>

      <el-form-item label="Latitude" prop="lat">
        <el-input v-model="clientData.latitude"></el-input>
      </el-form-item>

      <el-form-item label="Longitude" prop="long">
        <el-input v-model="clientData.longitude"></el-input>
      </el-form-item>

      <el-form-item label="Zoom" prop="zoom">
        <el-input v-model="clientData.zoom"></el-input>
      </el-form-item>

      <el-form-item label="Sunset Offset (minutes before)" prop="sunset_offset">
        <el-input-number v-model="clientData.sunset_offset"></el-input-number>
      </el-form-item>

      <el-form-item>
        <el-button type="save" @click="submit('clientData')">Save</el-button>
        <el-button type="cancel" @click="close">Cancel</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import auth from '../../../auth';
import requests from '../../../requests';

export default {
  name: 'admin-edit-client',
  props:['clientData'],
  data () {
    return {
      pageName: 'Edit Client',
      userIsSuperAdmin: false,
    }
  },
  methods: {
    editClient(){
      var clientData = this.clientData;

      var context = this;

      requests.updateClient(this, clientData, clientData.id, function (result) {
        if(result.action === 'success'){
          context.$message({
            showClose: true,
            type: 'success',
            message: 'Successfully edited client ' + clientData.name
          });

          context.close();

        } else {

          context.$message({
            showClose: true,
            type: 'error',
            message: 'Failed to edited client: ' + result.msg,
          });
        }
      });

    },
    submit(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editClient();
          this.reset(formName);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset(formName) {
      this.$refs[formName].resetFields();
    },
    close() {
      this.reset('clientData');
      this.$emit('close');
    }
  },
  beforeMount() {
    var profile = JSON.parse(auth.getProfile());
    this.userIsSuperAdmin = (profile.role === 3);
  }
}
</script>

<style>
  .admin-new-scene {
    display: none;
  }
  
  .show {
    display: block !important;
  }

</style>



// WEBPACK FOOTER //
// EditClient.vue?7d2cfdd9